import { Sparkles, TriangleAlert } from "lucide-react";
import { toast } from "sonner";

export default function MissingDocsCallout({ items }) {
  if (!items.length) return null;

  const handleGenerate = () =>
    toast.success("Checklist generated by Vault agent", {
      description: `${items.length} documents queued in the Vault agent's task list.`,
    });

  return (
    <div
      data-testid="missing-docs-callout"
      className="overflow-hidden rounded-3xl border border-[#FFE0B2] bg-[#FFF7EE]"
    >
      <div className="flex flex-wrap items-center gap-4 px-6 py-5">
        <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-2xl bg-orange-500/15 text-orange-700">
          <TriangleAlert className="h-5 w-5" strokeWidth={2.4} />
        </div>
        <div className="flex-1 min-w-[260px]">
          <div
            data-testid="missing-docs-eyebrow"
            className="text-[10px] font-bold uppercase tracking-[0.18em] text-orange-700"
          >
            {items.length} missing documents
          </div>
          <div className="mt-0.5 text-[15px] font-bold text-zinc-900">
            Your data room is short {items.length} files investors will ask for
          </div>
        </div>
        <button
          type="button"
          data-testid="missing-docs-generate"
          onClick={handleGenerate}
          className="inline-flex items-center gap-1.5 rounded-full bg-black px-4 py-2 text-[12px] font-semibold text-white transition-colors hover:bg-zinc-800"
        >
          <Sparkles className="h-3.5 w-3.5" strokeWidth={2.4} />
          Generate AI checklist
        </button>
      </div>

      <ul className="grid grid-cols-1 gap-px bg-[#FFE0B2]/60 px-px pb-px md:grid-cols-2">
        {items.map((it) => (
          <li
            key={it.id}
            data-testid={`missing-item-${it.id}`}
            className="flex items-center gap-3 bg-[#FFF7EE] px-5 py-3"
          >
            <span className="text-[10px] font-bold uppercase tracking-[0.14em] text-orange-700">
              {it.sectionName}
            </span>
            <span className="text-zinc-300">·</span>
            <span className="truncate text-[12.5px] font-semibold text-zinc-800">
              {it.name}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
